import { useState } from "react";
import { useNavigate } from "react-router";
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "@illustraclass/ui";
import { useAuth } from "../hooks/useAuth";

export function LoginPage() {
  const navigate = useNavigate();
  const {
    login,
    loginWithMagicLink,
    isLoading,
    error,
    clearError,
    isAuthenticated,
  } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [magicLinkSent, setMagicLinkSent] = useState(false);
  const [showMagicLink, setShowMagicLink] = useState(false);

  if (isAuthenticated) {
    void navigate("/dashboard", { replace: true });
    return null;
  }

  async function handleLogin(e: React.SyntheticEvent) {
    e.preventDefault();
    try {
      await login(email, password);
      void navigate("/dashboard");
    } catch {
      // L'erreur est gérée dans le store
    }
  }

  async function handleMagicLink(e: React.SyntheticEvent) {
    e.preventDefault();
    try {
      await loginWithMagicLink(email);
      setMagicLinkSent(true);
    } catch {
      // L'erreur est gérée dans le store
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">IllustraClass</CardTitle>
          <CardDescription>
            Connectez-vous pour accéder aux simulations
          </CardDescription>
        </CardHeader>
        <CardContent>
          {error && (
            <div
              role="alert"
              className="mb-4 rounded-md bg-destructive/10 p-3 text-sm text-destructive"
            >
              {error}
              <button
                onClick={() => {
                  clearError();
                }}
                className="ml-2 underline"
                type="button"
              >
                Fermer
              </button>
            </div>
          )}

          {magicLinkSent ? (
            <div className="text-center">
              <p className="mb-4 text-sm text-muted-foreground">
                Si un compte existe avec cet email, un lien de connexion a été
                envoyé. Vérifiez votre boîte de réception.
              </p>
              <Button
                variant="outline"
                onClick={() => {
                  setMagicLinkSent(false);
                  setShowMagicLink(false);
                }}
              >
                Retour
              </Button>
            </div>
          ) : showMagicLink ? (
            <form
              onSubmit={(e) => {
                void handleMagicLink(e);
              }}
              className="space-y-4"
            >
              <div className="space-y-2">
                <Label htmlFor="magic-email">Email</Label>
                <Input
                  id="magic-email"
                  type="email"
                  placeholder="votre@email.fr"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  required
                  autoComplete="email"
                />
              </div>
              <Button type="submit" className="w-full" disabled={isLoading}>
                {isLoading ? "Envoi en cours…" : "Envoyer le lien magique"}
              </Button>
              <Button
                type="button"
                variant="ghost"
                className="w-full"
                onClick={() => {
                  setShowMagicLink(false);
                }}
              >
                Retour à la connexion classique
              </Button>
            </form>
          ) : (
            <form
              onSubmit={(e) => {
                void handleLogin(e);
              }}
              className="space-y-4"
            >
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="votre@email.fr"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  required
                  autoComplete="email"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Mot de passe</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  required
                  autoComplete="current-password"
                />
              </div>
              <Button type="submit" className="w-full" disabled={isLoading}>
                {isLoading ? "Connexion…" : "Se connecter"}
              </Button>
              <Button
                type="button"
                variant="ghost"
                className="w-full"
                onClick={() => {
                  setShowMagicLink(true);
                }}
              >
                Connexion par lien magique
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </main>
  );
}
